var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "35px",
    viewBox: "0 0 34 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5732B1CB-E733-4A6C-ACA9-0D2378A74D45") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Legal-statements-svg-icons",
    transform: "translate(-150.000000, -184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-114-Copy",
    transform: "translate(151.000000, 185.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.35358511,6 L29.6464149,6 C30.9462641,6 32,7.05373595 32,8.35358511 L32,27 C32,30.3137085 29.3137085,33 26,33 L6.35358511,33 C5.05373595,33 4,31.9462641 4,30.6464149 L4,8.35358511 C4,7.05373595 5.05373595,6 6.35358511,6 Z",
    id: "Rectangle-Copy-31",
    stroke: "#788999",
    fill: "#E7EAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.35358511,4 L27.6464149,4 C28.9462641,4 30,5.05373595 30,6.35358511 L30,27 C30,29.209139 28.209139,31 26,31 L4.35358511,31 C3.05373595,31 2,29.9462641 2,28.6464149 L2,6.35358511 C2,5.05373595 3.05373595,4 4.35358511,4 Z",
    id: "Rectangle-Copy-31",
    stroke: "#788999",
    fill: "#E7EAF3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-31",
    stroke: "#788999",
    fill: "#FFFFFF",
    x: 0,
    y: 2,
    width: 28,
    height: 27,
    rx: 2.35358511
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.35358511,2 L25.6464149,2 C26.9462641,2 28,3.05373595 28,4.35358511 L28,9 L28,9 L0,9 L0,4.35358511 C2.84903598e-16,3.05373595 1.05373595,2 2.35358511,2 Z",
    id: "Rectangle-Copy-32",
    stroke: "#788999",
    fill: "#C5CCD7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-33",
    stroke: "#788999",
    fill: "#F8F9FC",
    strokeLinejoin: "round",
    x: 18,
    y: 0,
    width: 2,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-33",
    stroke: "#788999",
    fill: "#F8F9FC",
    strokeLinejoin: "round",
    x: 23,
    y: 0,
    width: 2,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-35",
    stroke: "#788999",
    fill: "#F8F9FC",
    strokeLinejoin: "round",
    x: 13,
    y: 0,
    width: 2,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-37",
    stroke: "#788999",
    fill: "#F8F9FC",
    strokeLinejoin: "round",
    x: 8,
    y: 0,
    width: 2,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-39",
    stroke: "#788999",
    fill: "#F8F9FC",
    strokeLinejoin: "round",
    x: 3,
    y: 0,
    width: 2,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E7EAF3",
    x: 3,
    y: 12,
    width: 6,
    height: 6,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    fill: "#E7EAF3",
    x: 11,
    y: 12,
    width: 6,
    height: 6,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    fill: "#E7EAF3",
    x: 19,
    y: 12,
    width: 6,
    height: 6,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E7EAF3",
    x: 3,
    y: 20,
    width: 6,
    height: 6,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    fill: "#E7EAF3",
    x: 11,
    y: 20,
    width: 6,
    height: 6,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-10-Copy-11",
    stroke: "#788999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "12.5 15.2633582 13.375676 16.5 15.5 13.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-10-Copy-11",
    stroke: "#788999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "20.5 15.2633582 21.375676 16.5 23.5 13.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-10-Copy-11",
    stroke: "#788999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "12.5 23.2633582 13.375676 24.5 15.5 21.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-10-Copy-11",
    stroke: "#788999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "4.5 23.2633582 5.37567597 24.5 7.5 21.5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    fill: "#E7EAF3",
    x: 19,
    y: 20,
    width: 6,
    height: 6,
    rx: 0.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.03f8c987621c0273cf33f63632704794.svg";
export { ForwardRef as ReactComponent };